import apiClient from "./interceptor"
import CryptoJS from 'crypto-js';

export const downloadExcel = async (startDate, endDate, password) => {
    try {
        const secretKey = '$3#DSM4@$&534&&$#@JK45@@@';
        const data = password.trim();
        const encryptedData = CryptoJS.AES.encrypt(data, secretKey).toString();
        const response = apiClient.get(`/v2/users/users/getMyflexaUsersJourneyData/${startDate}/${endDate}`, {
            headers: {
                key: encryptedData,
            }
        })
        return response;
    } catch (err) {
        console.log(err);
        return err;
    }
}